module.exports = "/static-assets/_next/static/images/sex-toys-9a4bd4d8e6e7dd4fd314c4427a0a74dd.png";